import { Currency, Token } from '@echodex/swap-sdk-core'
import { NATIVE, WETH9, ChainId } from '@echodex/sdk'
import { getAddress } from 'viem'
import useActiveWeb3React from './useActiveWeb3React'

type TokenType = {
    __typename?: 'Token' | undefined
    id: string
    name: string
    decimals: string
    symbol: string
}

export function convertToCurrency(chainId: number, token0Info: TokenType, nativeConvert = true): Currency {
    const chainIdToUse = chainId === ChainId.LINEA_MAINNET ? ChainId.LINEA_MAINNET : ChainId.LINEA_TESTNET
    const address = getAddress(token0Info.id)
    if (address === WETH9[chainIdToUse].address && nativeConvert) {
        return NATIVE[chainIdToUse] as Currency
    }
    return new Token(chainId, address, parseInt(token0Info.decimals), token0Info.symbol, token0Info.name) as Currency
}

const useConvertToCurrency = (token0Info: TokenType, nativeConvert = true) => {
    const { chainId } = useActiveWeb3React()
    return convertToCurrency(
        chainId === ChainId.LINEA_MAINNET ? ChainId.LINEA_MAINNET : ChainId.LINEA_TESTNET,
        token0Info,
        nativeConvert,
    )
}

export default useConvertToCurrency
